<ng-container *ngIf="size | lottieDimensions as dimensions">
  <ng-lottie [width]="dimensions.width" [height]="dimensions.height" [options]="type | lottieOptions"></ng-lottie>
</ng-container>
